<template>

    <div class="input-container">

        <label v-if="label" class="form-label">{{ label }}</label>

        <div class="input-group mb-0 bg-light-subtle rounded-3">

            <span class="input-group-text text-muted" v-if="icon">
                <i :class="icon"></i>
            </span>
        
            <textarea class="form-control form-control-lg border-light bg-light-subtle" :placeholder="placeHolder" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" :required="required" :rows="rows"></textarea>
            
        </div>

    </div>

</template>

<script>
export default {
    props: {
        label: {
            type: String
        },
        icon: {
            type: String,
        },
        placeHolder: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: [String, Number],
            default: ''
        },
        rows: {
            type: [Number],
            default: 3
        }
    }
};
</script>